export enum Alignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
